
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as index6ld8FU4L88P7uuvO_nGVIqyqtSyTJNQN59xrKkqwp_454Meta } from "/tmp/tmp2la0xefc/pages/index.vue?macro=true";
import { default as indexl62smXdoG73wJLcWT6erTnxb600_wns0LiT_45s3zPJLsMeta } from "/tmp/tmp2la0xefc/pages/[area]/index.vue?macro=true";
import { default as indexON8z_45BpgIxaroXnQ6gq8r7_45mGxNv0hnBvSFQdoDk7IsMeta } from "/tmp/tmp2la0xefc/pages/okinawa/index.vue?macro=true";
import { default as indexppXObf5GI_45JB6JqkwCKO_ix8PMuxXUhVGXurC5YxvyEMeta } from "/tmp/tmp2la0xefc/pages/zoom-map/index.vue?macro=true";
import { default as indexEoBUKtqWgMBwKpcspQA07ONzufntGYwX5e8_45Pw3x1WgMeta } from "/tmp/tmp2la0xefc/pages/okinawa/[id]/index.vue?macro=true";
import { default as indexg7T56rW6Rlc_45OhHQkwpkj5zIqJZ8RhaOkuo_FKkgpaYMeta } from "/tmp/tmp2la0xefc/pages/[area]/[pref]/index.vue?macro=true";
import { default as indexeQWjdeKvZqplpj36AM46TATYToMBvtotgzl1_454rcgycMeta } from "/tmp/tmp2la0xefc/pages/[area]/[pref]/[id]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/tmp2la0xefc/pages/index.vue")
  },
  {
    name: "area",
    path: "/:area()",
    component: () => import("/tmp/tmp2la0xefc/pages/[area]/index.vue")
  },
  {
    name: "okinawa",
    path: "/okinawa",
    component: () => import("/tmp/tmp2la0xefc/pages/okinawa/index.vue")
  },
  {
    name: "zoom-map",
    path: "/zoom-map",
    component: () => import("/tmp/tmp2la0xefc/pages/zoom-map/index.vue")
  },
  {
    name: "okinawa-id",
    path: "/okinawa/:id()",
    component: () => import("/tmp/tmp2la0xefc/pages/okinawa/[id]/index.vue")
  },
  {
    name: "area-pref",
    path: "/:area()/:pref()",
    component: () => import("/tmp/tmp2la0xefc/pages/[area]/[pref]/index.vue")
  },
  {
    name: "area-pref-id",
    path: "/:area()/:pref()/:id()",
    component: () => import("/tmp/tmp2la0xefc/pages/[area]/[pref]/[id]/index.vue")
  }
]